import { Box, Button, Paper, TextField, Typography } from '@mui/material';
import React, { useContext, useState } from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import Header from '../../components/global/Header';
import Autocomplete from '@mui/material/Autocomplete';
import moment from 'moment/moment';
import { UserContextData } from '../../context/AuthContext';
import client from '../../API/client';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

export const RecruiterJobPost = () => {
  const Recruiter = JSON.parse(localStorage.getItem('recruiter'));
   const [jobtype, setJobtype] = useState('');
  const [workplace, setWorkplace] = useState('');
  const [jobinfo, setJobinfo] = useState({
    jobtitle: '',
    joblocation: '',
    jobsalary: '',
    about: '',
    requirement: '',
  });
  var createdAt = moment(Date.now()).format('YYYY-MM-DD HH:mm:ss');

  const handleOnChange = (e) => {
    e.preventDefault();
    setJobinfo((prev) => {
      return {
        ...prev,
        [e.target.name]: e.target.value,
      };
    });
  };

  const handleSubmit = async () => {
    const recruiter_id = await Recruiter.recruiter_id;
    console.log(recruiter_id)
    const { jobtitle, joblocation, jobsalary, about, requirement } = jobinfo;

    const payload = {
      jobtitle,
      workplace,
      joblocation,
      jobsalary,
      about,
      requirement,
      recruiter_id,
      createdAt,
      jobtype,
    };
    console.log(payload);
    try {
      await client
        .post('/job-post', payload, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
        })
        .then(async (res) => {
          if (res.status === 200) {
            toast.success('Job Posted Succesfully !!', {
              position: toast.POSITION.TOP_CENTER,
            });
            setJobinfo({
              jobtitle: '',
              joblocation: '',
              jobsalary: '',
              about: '',
              requirement: '',
            });
            setWorkplace('')
            setJobtype('')
          } else {
            toast.error('OOps!! Something went wrong ', {
              position: toast.POSITION.TOP_CENTER,
            });
          }
        })
        .catch((err) => {
          toast.error('Enter the required Field !!', {
            position: toast.POSITION.TOP_CENTER,
          });
        });
    } catch (error) {
      console.log(error);
    }
  };

  const Jobtype = [
    { label: 'Full-time' },
    { label: 'Part-time' },
    { label: 'Temporary' },
    { label: 'volunteer' },
    { label: 'Contract' },
  ];

  const workplacetype = [
    { label: 'Hybrid' },
    { label: 'On-site' },
    { label: 'Remote' },
  ];
  return (
    <>
      <Container fluid style={{ margin: '20px' }}>
        <ToastContainer />
        <Header title="Create a new job" subtitle="Hello recruiter " />
        <Row>
          <Col xs={11}>
            <Paper elevation={3} pb="30px" style={{ marginTop: '10px' }}>
              <Box p="20px">
                <Typography variant="h6">
                  Fill the Required details to post a job
                </Typography>
                <Box mt="10px">
                  <TextField
                    label="Job Title*"
                    name="jobtitle"
                    value={jobinfo.jobtitle}
                    onChange={handleOnChange}
                    variant="outlined"
                    style={{
                      width: '30%',
                      margin: '10px',
                    }}
                  />
                  <TextField
                    label="Salary*"
                    name="jobsalary"
                    value={jobinfo.jobsalary}
                    onChange={handleOnChange}
                    variant="outlined"
                    style={{
                      width: '26%',
                      margin: '10px',
                    }}
                  />

                  <TextField
                    label="Job Location*"
                    name="joblocation"
                    value={jobinfo.joblocation}
                    onChange={handleOnChange}
                    variant="outlined"
                    style={{
                      width: '30%',
                      margin: '10px',
                    }}
                  />
                  <TextField
                    label="Requirements*"
                    name="requirement"
                    value={jobinfo.requirement}
                    onChange={handleOnChange}
                    multiline={true}
                    rows={2}
                    variant="outlined"
                    style={{
                      width: '90%',
                      margin: '10px',
                    }}
                  />
                  <Autocomplete
                    id="combo-box-demo"
                    name="jobtype"
                    value={jobtype}
                    onChange={(event, value) => setJobtype(value.label)}
                    options={Jobtype}
                    style={{
                      width: '90%',
                      margin: '10px',
                      marginBottom: '20px',
                    }}
                    isOptionEqualToValue={(option, value) =>
                      option.iso === value.iso
                    }
                    renderInput={(params) => (
                      <TextField {...params} label="Job Type*" />
                    )}
                  />
                  <Autocomplete
                    id="combo-box-demo"
                    name="workplace"
                    value={workplace}
                    onChange={(event, value) => setWorkplace(value.label)}
                    options={workplacetype}
                    isOptionEqualToValue={(option, value) =>
                      option.iso === value.iso
                    }
                    style={{
                      width: '90%',
                      margin: '10px',
                    }}
                    renderInput={(params) => (
                      <TextField {...params} label="Workplace Type*" />
                    )}
                  />

                  <TextField
                    label="About / Description"
                    name="about"
                    value={jobinfo.about}
                    onChange={handleOnChange}
                    variant="outlined"
                    multiline={true}
                    rows={5}
                    style={{
                      width: '90%',
                      margin: '10px',
                    }}
                  />

                  <Button
                    variant="contained"
                    onClick={() => handleSubmit()}
                    sx={{ margin: '10px', width: '90%' }}>
                    Post Job
                  </Button>
                </Box>
              </Box>
            </Paper>
          </Col>
        </Row>
      </Container>
    </>
  );
};
